// import assign from 'lodash.assign';

const { createHigherOrderComponent } = wp.compose;
const { Fragment } = wp.element;
const { InspectorControls } = wp.editor;
const { PanelBody, SelectControl } = wp.components;
const { addFilter } = wp.hooks;
// const { __ } = wp.i18n;

// Enable slider control on the following blocks
const RevSliderGalleryAddOnBlocks = [
	'core/gallery',
];

/**
 * Add slider control attribute to block.
 *
 * @param {object} settings Current block settings.
 * @param {string} name Name of block.
 *
 * @returns {object} Modified block settings.
 */
const RevSliderGalleryAddOnAddControl = ( settings, name ) => {
	// Do nothing if it's another block than our defined ones.
	if ( ! RevSliderGalleryAddOnBlocks.includes( name ) ) {
		return settings;
	}

	settings.attributes = jQuery.extend(true, settings.attributes, {
		slider: {
			type: 'string',
			default: RevSliderGalleryAddOnOptions.default,
		},
	} );

	return settings;
};

addFilter( 'blocks.registerBlockType', 'revslider-gallery-addon-gutenberg-extension/attribute/slider', RevSliderGalleryAddOnAddControl );

/**
 * Add Slider Option to Block
 */
const RevSliderGalleryAddOn = createHigherOrderComponent( ( BlockEdit ) => {
	return ( props ) => {
		// Do nothing if it's another block than our defined ones.
		if ( ! RevSliderGalleryAddOnBlocks.includes( props.name ) ) {
			return (
				<BlockEdit { ...props } />
			);
		}

		const { slider } = props.attributes;

		// add revslider-gallery-addon-alias prefix class name
		if ( slider ) {
			props.attributes.className = `revslider-gallery-${ slider }`;
		}

		return (
			<Fragment>
				<BlockEdit { ...props } />
				<InspectorControls>
					<PanelBody
						title={ 'Slider Revolution Gallery' }
						initialOpen={ true }
					>
						<SelectControl
							label={ 'Select Slider' }
							value={ slider }
							options={ RevSliderGalleryAddOnOptions.sliders }
							onChange={ ( selectedSliderOption ) => {
								props.setAttributes( {
									slider: selectedSliderOption,
								} );
							} }
						/>
					</PanelBody>
				</InspectorControls>
			</Fragment>
		);
	};
}, 'RevSliderGalleryAddOn' );

addFilter( 'editor.BlockEdit', 'revslider-gallery-addon-gutenberg-extension/with-slider-control', RevSliderGalleryAddOn );

/**
 * Assign alias to block class name
 *
 * @param {object} saveElementProps Props of save element.
 * @param {Object} blockType Block type information.
 * @param {Object} attributes Attributes of block.
 *
 * @returns {object} Modified props of save element.
 */
const addRevSliderExtraProps = ( saveElementProps, blockType, attributes ) => {
	// Do nothing if it's another block than our defined ones.
	if ( ! RevSliderGalleryAddOnBlocks.includes( blockType.name ) ) {
		return saveElementProps;
	}
	
	jQuery.extend(true, saveElementProps, { slider: { 'alias': attributes.slider } } );
	return saveElementProps;
};

addFilter( 'blocks.getSaveContent.extraProps', 'revslider-gallery-addon-gutenberg-extension/get-save-content/extra-props', addRevSliderExtraProps );
